// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___rtQl6","overlayModal":"style__overlayModal___vRY2A","overlayModalInner":"style__overlayModalInner___3UkDB","overlayCloseButton":"style__overlayCloseButton___3UOY1","overlayModalTitle":"style__overlayModalTitle___nvQkx","overlayModalText":"style__overlayModalText___3mpGK","overlayModalTextBold":"style__overlayModalTextBold___1stv-","overlayModalButtons":"style__overlayModalButtons___3pbPW","overlayModalButtonsItem":"style__overlayModalButtonsItem___1WI0n","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___uzA1P","buttonActive":"style__buttonActive___3T-PS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-imagesize/style.css
// module id = 807
// module chunks = 0